import { Configuration, PopupRequest } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: '33e04e3b-f4b7-42fc-95c5-6d4e33a0cc87',
    authority: 'https://login.microsoftonline.com/07d3cdfa-42d1-4b8f-a272-5d351096485f',
    redirectUri: window.location.origin

  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  }
};

export const loginRequest: PopupRequest = {
  scopes: ['User.Read']
};
